export const RISK_LABELS = { rendah: "Rendah", sedang: "Sedang", tinggi: "Tinggi", kritis: "Kritis" };

export const RISK_STYLES = {
  rendah: "bg-emerald-50 text-emerald-700 border-emerald-200",
  sedang: "bg-amber-50 text-amber-700 border-amber-300",
  tinggi: "bg-red-50 text-red-700 border-red-300",
  kritis: "bg-red-900 text-red-50 border-red-900",
};

export const STATUS_LABELS = {
  tidak_perlu_investigasi: "Tanpa Investigasi",
  menunggu_penugasan: "Menunggu Penugasan",
  menunggu_approval: "Menunggu Approval",
  ditugaskan: "Ditugaskan",
  selesai: "Selesai",
};

export const STATUS_STYLES = {
  tidak_perlu_investigasi: "bg-gray-100 text-gray-600 border-gray-200",
  menunggu_penugasan: "bg-blue-50 text-blue-700 border-blue-200",
  menunggu_approval: "bg-violet-50 text-violet-700 border-violet-200",
  ditugaskan: "bg-sky-50 text-sky-700 border-sky-200",
  selesai: "bg-emerald-50 text-emerald-700 border-emerald-200",
};

export const REC_LABELS = { tidak_perlu: "Tanpa Investigasi", internal: "Investigator Internal", eksternal: "Investigator Eksternal" };

export const ROLE_LABELS = {
  admin: "Admin", supervisor: "Supervisor", staff: "Staf Klaim",
  investigator_internal: "Investigator Internal", investigator_eksternal: "Investigator Eksternal",
};

export const RiskBadge = ({ category, className = "" }) => (
  <span data-testid={`risk-badge-${category}`}
    className={`inline-flex items-center px-2 py-0.5 text-xs font-semibold border ${RISK_STYLES[category] || ""} ${className}`}>
    {RISK_LABELS[category] || category}
  </span>
);

export const StatusBadge = ({ status }) => (
  <span data-testid={`status-badge-${status}`}
    className={`inline-flex items-center px-2 py-0.5 text-xs font-medium border ${STATUS_STYLES[status] || "bg-gray-100 text-gray-600 border-gray-200"}`}>
    {STATUS_LABELS[status] || status}
  </span>
);

export const ScorePill = ({ score }) => {
  const color = score >= 80 ? "text-red-50 bg-red-900" : score >= 60 ? "text-red-700 bg-red-50 border border-red-200"
    : score >= 40 ? "text-amber-700 bg-amber-50 border border-amber-200" : "text-emerald-700 bg-emerald-50 border border-emerald-200";
  return <span data-testid="score-pill" className={`inline-flex items-center justify-center min-w-[2.5rem] px-2 py-0.5 text-sm font-bold font-mono ${color}`}>{score}</span>;
};
